<template>
  <div class="box">
    <div class="title d-flex j-sb a-center">
      <span class="col-main">角色切换</span>
      <i class="el-icon-close col-main crr" @click="closeLoginTip"></i>
    </div>
    <div class="options">
      <div class="list crr d-flex j-sb a-center"
        v-for="(item, index) in roles" :key="index"
        @click="chooseRole(item.role_id)">
        <div class="left">
          <span>{{item.name}}</span>
          <span class="col-main">{{item.role_name}}</span>
        </div>
        <p class="yuan d-flex a-center j-center" :class="{active: active == item.role_id}">
          <i class="el-icon-check" v-if="active == item.role_id"></i>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data () {
    return {
      active: 1,
      roles: []
    }
  },
  created() {
    this.roles = this.$utils.getItem('roles')
    this.active = this.$store.state.roleId
  },
  methods: {
    closeLoginTip() {
      this.$store.commit('setChangeRole',false)
    },
    chooseRole(roleId) {
      if (roleId == this.active) {
        return
      }
      this.active = roleId
      this.$store.commit('setUserRole',roleId)
      this.closeLoginTip()
      if (this.$route.path == '/course/online-details') {
        this.$router.replace(`/course/online-detailsToken?course_id=${this.$route.query.course_id}&learnType=COURSE&train_id=${this.$route.query.train_id || ''}`)
      } else if (this.$route.path == '/course/practice-details') {
        this.$router.replace(`/course/practice-detailsToken?course_id=${this.$route.query.course_id}&learnType=COURSE&train_id=${this.$route.query.train_id || ''}`)
      } else if(this.$route.path == '/course/plan-details') {
        this.$router.replace(`/course/plan-detailsToken?train_id=${this.$route.query.train_id}`)
      } else {
        if (this.$route.path !== '/home') {
          this.$router.replace('/home')
        } else {
          this.$router.go(0)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box{
  width: 583px;
  border-radius: 8px;
  background: #fff;
  overflow: hidden;
  .title{
    background: #E1F7ED;
    height: 56px;
    padding: 0 20px;
    font-size: 22px;
  }
  .options{
    padding: 20px;
    max-height: 600px;
    overflow-y: scroll;
    .list{
      margin-bottom: 15px;
      height: 60px;
      padding: 0 30px;
      border-radius: 8px;
      border: 1px solid #CBCBCB;
      .left{
        span:first-child{
          font-size: 20px;
        }
        span:last-child{
          padding: 0 11px;
          height: 32px;
          line-height: 32px;
          background: rgba(#03B355, 0.13);
          border-radius: 16px;
          margin-left: 20px;
        }
      }
      .yuan{
        width: 20px;
        height: 20px;
        border: 1px solid #CBCBCB;
        border-radius: 50%;
        .el-icon-check{
          color: #fff;
        }
      }
      .active{
        background: #03B355;
        border-color: #03B355;
      }
    }
  }
}
</style>
